export default {
  textToSpeech: {
    onLabel: 'Desactivar texto a voz',
    offLabel: 'Activar texto a voz',
    error:
      '¡Encontramos un error con el texto a voz! Por favor, intenta de nuevo después de un tiempo.',
  },
  speechToText: {
    offLabel: 'Haz clic en el icono del micrófono para hablar',
    onLabel: 'Escuchando...',
    loadingLabel: 'Conectando...',
    error:
      '¡Encontramos un error con el micrófono! Por favor, intenta cambiar al modo de teclado.',
    permissionDeniedError:
      '¡Permiso denegado para usar el micrófono! Por favor, intenta cambiar al modo de teclado.',
  },
  progress: 'Progreso',
  completionMessage:
    'El paciente ya ha completado esta conversación con formularios y medicamentos.',
  responseError: 'Hubo un error al generar una respuesta',
  emptyMessageWarning: 'Por favor, añade un mensaje para enviar',
  edit: 'Editar',
  regenerateResponse: 'Regenerar Respuesta',
  controls: {
    placeholder: 'Enviar un mensaje',
    send: 'Enviar',
  },
  feedback: {
    submitSuccess: '¡Feedback enviado!',
    submitError: '¡Error al enviar feedback!',
  },
  chatCompletion: {
    error:
      '¡Error al completar el chat! ¡No te preocupes, tus datos están guardados con nosotros!',
    chat: {
      successMessage:
        '¡Gracias por completar la conversación! Para garantizar tu privacidad y confidencialidad, por favor haz clic en el botón de Cerrar sesión.',
    },
    form: {
      successMessage:
        '¡Gracias por completar el formulario! Para garantizar tu privacidad y confidencialidad, por favor haz clic en el botón de Cerrar sesión.',
    },
    logoutButton: 'Cerrar sesión',
  },
};
